import axiosApi from "core/request";
import { IAllRequestsParams, IAllRequestsResponse } from "store/slices/reguestsSlice";

import { createAsyncThunk } from "@reduxjs/toolkit";

export const getRequests = createAsyncThunk<
  IAllRequestsResponse,
  IAllRequestsParams,
  { rejectValue: string }
>(
  "requests/getRequests",
  async (params, { rejectWithValue }) => {
    try {
      const response = await axiosApi.get<IAllRequestsResponse>(
        "/personal-cabinet/calendar/daysoff/requests",
        {
          params: {
            pageNumber: params.pageNumber,
            pageSize: params.pageSize,
            "filter.name": params.filter?.name,
            "filter.status": params.filter?.status,
            "filter.createdDateTime": params.filter?.createdDateTime,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data || error.message
      );
    }
  }
);